module.exports = __webpack_public_path__ + "img/ic_file-signed.e6421f37.png";